export const menuItemsPermission = {
    menuItemsViewTracker: "menu-item.view-tracker",
    menuItemsViewScheduler: "menu-item.view-scheduler",
    menuItemsViewConfigManager: "menu-item.view-config-manager",
    menuItemsViewCredentials: "menu-item.view-credentials",
    menuItemsViewCredentialsTypes: "menu-item.view-credentials-types",
    menuItemsViewProxies: "menu-item.proxy-manager",
    menuItemsViewQuotaLimits: "menu-item.view-quota-manager",
    menuItemsViewConfigCi: "menu-item.view-config-ci",
    menuItemsViewUsers: "menu-item.view-users",
    menuItemsViewRoles: "menu-item.view-roles",
    menuItemsViewBranches: "menu-item.view-branches",
    menuItemsViewBrands: "menu-item.view-brands",
    menuItemsViewUserAgent: "menu-item.view-user-agent",
    menuItemsViewObjectStructures: "menu-item.view-object-structures",
    menuItemsViewPrimaryKey: "menu-item.view-primary-key",
    menuItemsViewSiteGroup: "menu-item.view-site-group",
    menuItemsViewBrandTrackedDomains: "menu-item.view-brand-tracked-domains",
    menuItemsViewSQSQueues: "menu-item.view-sqs-queues",
    menuItemsViewInitialScrapeTaskBatchStarts: "menu-item.view-initial-scrape-task-batch-starts",
};
